var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paintings-slider",style:({
    cursor: _vm.cursor
  }),on:{"click":_vm.cursorGoTo}},[_c('div',{ref:"container",style:({ height: '100%', width: '100%' })},[_c('TvaSlider',{attrs:{"config":{ arrows: false, dots: false },"startIndex":_vm.getPaint.index,"sliderGoTo":_vm.sliderGoTo,"cursor":false},on:{"change":_vm.changePaint}},_vm._l((_vm.$ml.get('data')),function(paint){return _c('div',{key:paint.id,class:[
          'slide',
          {
            selected: paint.index === _vm.getPaint.index,
            prevTwo: paint.index === _vm.getPaint.index - 2,
            prevOne: paint.index === _vm.getPaint.index - 1,
            nextOne: paint.index === _vm.getPaint.index + 1,
            nextTwo: paint.index === _vm.getPaint.index + 2,
            outside:
              paint.index > _vm.getPaint.index + 2 ||
              paint.index < _vm.getPaint.index - 2
          }
        ],on:{"mousemove":_vm.changeCursor,"mouseleave":function($event){_vm.cursor = 'initial'}}},[_c('img',{class:['image'],style:({
            opacity: paint.shape === 'rettangolo' ? 1 : 0,
            height:
              paint.height / paint.width < 0.9 && _vm.$tvaMq === 'mobile'
                ? '60%'
                : '100%'
          }),attrs:{"data-flickity-lazyload":_vm.src(paint)}}),(paint.shape !== 'rettangolo')?_c('svg',{staticClass:"svg",style:({
            left: ("calc(50% - " + ((_vm.height * (paint.width / paint.height)) /
              2) + "px")
          }),attrs:{"width":_vm.height * (paint.width / paint.height) + 'px',"height":"100%","viewBox":("0 0 " + (_vm.masks[paint.id].artBoard.width) + " " + (_vm.masks[paint.id].artBoard.height))}},[_c('defs',[_c('clipPath',{attrs:{"id":("svgPath-" + (paint.id))}},[_c('path',{attrs:{"d":_vm.masks[paint.id].path}})])]),_c('image',{attrs:{"clip-path":("url(#svgPath-" + (paint.id) + ")"),"height":"100%","width":"100%","xlink:href":_vm.src(paint)}})]):_vm._e()])}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }